import { apiSlice } from "../../app/api/apiSlice";


export const rbacApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({

        getOrganisationModules: builder.mutation({
            query: (credentials) => ({
                url: `/rbac/modules`,
                method: "GET",
            }),
        }),
        getOrganisationRolesWithPermissions: builder.mutation({
            query: (credentials) => ({
                url: `/rbac/list-with-permissions`,
                method: "GET",
            }),
        }),

        savePermissions: builder.mutation({
            query: (credentials) => ({
                url: `/rbac/save-role-permissions`,
                method: "POST",
                body: credentials
            })
        })

    }),
});

export const {
    useGetOrganisationModulesMutation,
    useGetOrganisationRolesWithPermissionsMutation,
    useSavePermissionsMutation
} = rbacApiSlice;
